import { TypePolicies } from '@apollo/client';
import { applicationTypePolicy } from '~/apollo/applicationTypePolicy';
import { applicationUserTypePolicy } from '~/apollo/applicationUserTypePolicy';
import { audioFileTypePolicy } from '~/apollo/audioFileTypePolicy';
import { trackTypePolicy } from '~/apollo/trackTypePolicy';
import { contentSourceTypePolicy } from '~/apollo/contentSourceTypePolicy';
import { playlistTypePolicy } from '~/apollo/playlistTypePolicy';

export const typePolicies: TypePolicies = {
  Playlist: playlistTypePolicy,
  ApplicationUser: applicationUserTypePolicy,
  Application: applicationTypePolicy,
  AudioFile: audioFileTypePolicy,
  ContentSource: contentSourceTypePolicy,
  Track: trackTypePolicy,
};
